import {Component, inject} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {InputFieldComponent} from '../../../shared/components/form/input/input-field.component';
import {ButtonComponent} from '../../../shared/components/ui/button/button.component';
import {LabelComponent} from '../../../shared/components/form/label/label.component';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {SnackbarService} from '@shared/services/snackbar.service';
import {LoginService} from '../login/login.service';

@Component({
  selector: 'app-reset-password',
  imports: [
    ButtonComponent,
    LabelComponent,
    InputFieldComponent,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './reset-password.html'
})
export class ResetPassword {
  showPassword = false;
  showConfirmPassword = false;
  isLoading = false;
  token: string | null = null;

  emailForm!: FormGroup;
  passwordForm!: FormGroup;

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private fB = inject(FormBuilder);
  private snackbarService = inject(SnackbarService);
  private loginService = inject(LoginService);

  constructor() {
    this.token = this.route.snapshot.queryParamMap.get('token');
    this.makeForm();
  }

  private makeForm() {
    this.emailForm = this.fB.group({
      email: [null, [Validators.required, Validators.email]],
    });

    this.passwordForm = this.fB.group({
      password: [null, [Validators.required, Validators.minLength(8)]],
      password_confirmation: [null, Validators.required],
    });
  }

  requestReset() {
    if (!this.emailForm.valid) return;

    this.isLoading = true;
    this.loginService.forgotPassword(this.emailForm.value).subscribe({
      next: (response) => {
        this.snackbarService.showSnackBar(response.message || 'Se ha enviado un correo con las instrucciones para restablecer tu contraseña');
      },
      error: (err) => {
        this.snackbarService.showSnackBar(err.error?.message || 'Error al enviar el correo');
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  resetPassword() {
    if (!this.passwordForm.valid) return;

    if (this.passwordForm.value.password !== this.passwordForm.value.password_confirmation) {
      this.snackbarService.showSnackBar('Las contraseñas no coinciden');
      return;
    }

    if (!this.token) {
      this.snackbarService.showSnackBar('Token de recuperación no válido');
      return;
    }

    this.isLoading = true;
    const resetData = {
      email: this.emailForm.value.email,
      token: this.token,
      password: this.passwordForm.value.password,
      password_confirmation: this.passwordForm.value.password_confirmation
    };

    this.loginService.resetPassword(resetData).subscribe({
      next: (response) => {
        this.snackbarService.showSnackBar(response.message || 'Contraseña restablecida exitosamente');
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.snackbarService.showSnackBar(err.error?.message || 'Error al restablecer la contraseña');
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
}
